import { dispatchUpdatedEntityEventParams } from '@/domains/contacts/sagas/types';
import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';
import ContactEvents from '@/domains/contacts/events';
import EventService from '@/services/EventService/EventService';

export function dispatchUpdatedEntityEvent({
  claimSetId,
  entityKey,
  entityType,
  eventType = ContactEvents.ContactCreated,
}: dispatchUpdatedEntityEventParams) {
  try {
    if (entityType === EdsEntityCodes.ClaimSet && entityKey != null) {
      return EventService.dispatch(
        new eventType({
          entityType: EdsEntityCodes.ClaimSet,
          entityKey: String(claimSetId),
        }),
      );
    } else if ([EdsEntityCodes.ClaimEntity, EdsEntityCodes.Claim].includes(entityType) && entityKey != null) {
      return EventService.dispatch(
        new eventType({
          entityType: EdsEntityCodes.ClaimEntity,
          entityKey: String(entityKey),
        }),
      );
    } else if (entityKey != null) {
      return EventService.dispatch(
        new eventType({
          entityType: entityType,
          entityKey: String(entityKey),
        }),
      );
    }
  } catch (error) {
    console.error(error);
  }
}
